import { render, staticRenderFns } from "./ProfilsDesInvestisseurs.vue?vue&type=template&id=5ebd9f1c&"
import script from "./ProfilsDesInvestisseurs.vue?vue&type=script&lang=js&"
export * from "./ProfilsDesInvestisseurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports